<template>
	<div class="h-100 d-flex flex-column align-center justify-center">
		<p>Vous n'avez pour le moment aucune organisation.</p>
		<p>Essayez de contacter un administrateur.</p>
	</div>
</template>
